import '../App.css';
import HeaderBar from '../HeaderObject.js';
import FooterBar from '../FooterObject.js';
import Banner from '../banner.js';
import CodeBlock from '../CodeBlock.js';
import DetailsWindow from '../DetailWindow.js';

import { Fade } from 'react-reveal';

export default function TdPage(){
    return(
        <div className='App'>
            <HeaderBar />
            <Banner 
                title={"Tower Defense"}
                textCol={"#000"}
                height={"450px"}
                image={"https://safebuckledev.github.io/img/banner_td.PNG"}
            />

            <Fade bottom distance="40%" duration={750}>
            </Fade>

            <article>
                <Fade bottom distance="40%" duration={750}>
                    <h1 className='TitleText'>Wave System</h1>
                </Fade>

                <section>
                    <DetailsWindow 
                        details={'For the wave system, I aimed to make it as flexible as possible so that it is highly scalable and easy to add new elements. I developed a simple system that allows you to create waves easily using scriptable objects. A "Wave Object" is divided into waves and segments. Each wave consists of multiple segments where enemies can be spawned at a portal. You can assign a "portal ID" so that an enemy spawns at a specific portal, along with a timer to determine how long until the next enemy spawns.'}
                        image={"https://safebuckledev.github.io/img/td/TD_Wave.png"}
                    />

                    <Fade bottom distance="40%" duration={750}>
                        <CodeBlock 
                            data={'public IEnumerator WavePlayer()\n    {\n        foreach (Waves wave in waves.waves) // run trough all waves in the WaveObject\n        {\n            startRoundTime = wave.waveStartWaitTime;\n            yield return new WaitForSeconds(wave.waveStartWaitTime);\n\n            messenger.text = "Wave  in  progress...";\n            waveProgSlider.gameObject.SetActive(true);\n            waveProgSlider.maxValue = wave.segments.Count;\n            waveProgSlider.value = 0;\n\n            foreach (Portal portal in portals) // opens portal visual at the start of wave\n            {\n                portal.openPortal = true;\n                portal.ChangePortalSetting(Portal.PortalOptions.open);\n            }\n            yield return new WaitForSeconds(portals[0].duration);\n\n            foreach (WaveSegment segment in wave.segments) // loops trough all spawn enemies inside wave segment\n            {\n                Instantiate(segment.enemy, portals[segment.portalId].spawnAnchor.position, portals[segment.portalId].spawnAnchor.rotation);\n\n                yield return new WaitForSeconds(segment.waitTime); // waits between spawning enemy given by their waitTime\n            }\n\n            foreach (Portal portal in portals) // closes portal visual at the end of wave\n            {\n                portal.ChangePortalSetting(Portal.PortalOptions.close);\n            }\n\n            yield return new WaitUntil(canContinueNextRound); // small wait time until next wave\n            waveProgSlider.gameObject.SetActive(false);\n        }\n}'}
                        />
                    </Fade>
                </section>
            </article>

            <FooterBar />
        </div>
    );
}